// /* Made Foods — Collection Switcher
//    - Keeps full page UI on refresh by pushing ?view=full-menu
//    - Fetches lightweight ?view=grid-only for fast swaps
//    - Intercepts pagination + back/forward; scrolls to grid on page change only
//    - Cleans phcursor; normalizes links; syncs active pill
//    - Safe fallback to full navigation if fetch fails
//    - Toggle KEEP_VIEW_FULLMENU=false later when collections use the full template
// */
(() => {
  if (window.__collectionSwitcherInit) return;
  window.__collectionSwitcherInit = true;

  document.addEventListener('DOMContentLoaded', () => {
    const KEEP_VIEW_FULLMENU = false;

    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return; // nothing to do

    // a11y basics (once)
    if (!grid.hasAttribute('role')) {
      grid.setAttribute('role', 'region');
      grid.setAttribute('aria-live', 'polite');
      grid.setAttribute('aria-label', 'Products');
    }

    // --- helpers ---
    const toURL = (u) => (typeof u === 'string' ? new URL(u, location.origin) : new URL(location.href));
    const getPage = (url) => toURL(url).searchParams.get('page') || '1';
    let lastPage = getPage(location.href);

    const buildFetchURL = (base) => {
      const u = toURL(base);
      u.searchParams.delete('phcursor');
      u.searchParams.set('view', 'grid-only');
      return u;
    };
    const buildPushURL = (base) => {
      const u = toURL(base);
      u.searchParams.delete('phcursor');
      if (KEEP_VIEW_FULLMENU) u.searchParams.set('view', 'full-menu');
      else u.searchParams.delete('view');
      return u;
    };

    const normalizePaginationLinks = (scope) => {
      (scope || document).querySelectorAll('.pagination a').forEach((a) => {
        const u = toURL(a.href);
        u.searchParams.delete('phcursor');
        if (KEEP_VIEW_FULLMENU) u.searchParams.set('view', 'full-menu');
        else u.searchParams.delete('view');
        a.href = u.toString();
        a.setAttribute('data-pagination-link', '1');
      });
    };

    const getHeaderOffset = () => {
      const header = document.querySelector('header, .shopify-section-header-sticky, .header-wrapper');
      return header ? header.getBoundingClientRect().height : 0;
    };

    const scrollToGridTopIfPageChanged = (urlLike) => {
      const current = getPage(urlLike);
      if (current !== lastPage) {
        const top = grid.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 12;
        window.scrollTo({ top, behavior: 'smooth' });
        lastPage = current;
      } else {
        lastPage = current;
      }
    };

    const syncActivePillToURL = () => {
      const current = location.pathname.split('/').pop();
      document.querySelectorAll('[data-collection-link]').forEach((a) => {
        const target = toURL(a.href).pathname.split('/').pop();
        a.classList.toggle('active', target === current);
      });
    };

    const swapGridFromHTML = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('ProductGridContainer');
      if (!newGrid) return false;
      grid.innerHTML = newGrid.innerHTML;
      grid.style.opacity = '1';
      normalizePaginationLinks(grid);
      // focus for a11y (no scroll jump)
      grid.setAttribute('tabindex', '-1');
      grid.focus({ preventScroll: true });
      return true;
    };

    const fetchAndSwap = (targetURL) => {
      const fetchURL = buildFetchURL(targetURL);
      if (grid) grid.style.opacity = '0.3';
      return fetch(fetchURL.toString())
        .then((r) => r.text())
        .then((html) => {
          if (!swapGridFromHTML(html)) throw new Error('Grid not found in response');
        })
        .catch(() => {
          if (grid) grid.style.opacity = '1';
          // hard fallback to a full navigation so the user isn’t stuck
          location.href = buildPushURL(targetURL).toString();
        });
    };

    const trackVirtualPageview = (pushURL) => {
      try {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'virtual_pageview',
            page_location: pushURL.href || pushURL.toString(),
            page_path: pushURL.pathname + pushURL.search,
            page_title: document.title,
          });
        }
        if (window.fbq) {
          const u = typeof pushURL === 'string' ? new URL(pushURL, location.origin) : pushURL;
          window.fbq('trackCustom', 'CollectionNavigate', {
            collection: location.pathname.split('/').pop(),
            page: u.searchParams.get('page') || '1',
          });
        }
      } catch (e) {}
    };
    // --- end helpers ---

    // Prefetch on hover (skip if Save-Data or very slow conn)
    document.querySelectorAll('[data-collection-link]').forEach((link) => {
      link.addEventListener('mouseover', () => {
        if (link.dataset.prefetched) return;
        const c = navigator.connection;
        if (c && (c.saveData || c.downlink < 1)) return;
        fetch(buildFetchURL(link.href).toString(), { method: 'GET' });
        link.dataset.prefetched = '1';
      });

      // Pill click: switch collection via AJAX (no scroll)
      link.addEventListener('click', (e) => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();

        // active pill instantly
        document.querySelectorAll('[data-collection-link]').forEach((l) => l.classList.remove('active'));
        link.classList.add('active');

        const pushURL = buildPushURL(link.href);
        history.pushState({}, '', pushURL.pathname + pushURL.search);
        fetchAndSwap(link.href).then(() => {
          trackVirtualPageview(pushURL);
          lastPage = getPage(pushURL);
        });
      });
    });

    // Delegated pagination click (scroll only when page changes)
    document.addEventListener('click', (e) => {
      const a = e.target.closest('.pagination a, [data-pagination-link]');
      if (!a) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();

      const pushURL = buildPushURL(a.href);
      history.pushState({}, '', pushURL.pathname + pushURL.search);
      fetchAndSwap(a.href).then(() => {
        scrollToGridTopIfPageChanged(pushURL.toString());
        trackVirtualPageview(pushURL);
      });
    });

    // Back/forward
    window.addEventListener('popstate', () => {
      fetchAndSwap(location.href).then(() => {
        normalizePaginationLinks(grid);
        scrollToGridTopIfPageChanged(location.href);
        syncActivePillToURL();
      });
    });

    // Initial pass
    normalizePaginationLinks(document);
    syncActivePillToURL();
  });
})();


